/* eslint-disable import/no-unresolved */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";

import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import PowerBIAccess from "../../../dataAccess/PowerBIAccess";
import "powerbi-report-authoring";
import { useLocation } from "react-router-dom";

const PowerBiChart = (props) => {
  // const { location: { state: { reportId, datasetId } } } = props;
  const location = useLocation();

  const datasetId = location.state?.datasetId;
  const reportId = location.state?.reportId;
  const measureId = location.state?.measureId;
  const clientId = location.state?.clientId;

  const reportClass = "report-container";
  const [sampleReportConfig, setReportConfig] = useState({
    type: "report",
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  });

  useEffect(() => {
    PowerBIAccess.getAccessToken().then((response) => {
      let accessToken = response.data.access_token;
      let groupId = "9c08aedc-a169-406a-a0eb-95e4f299391f";

      if (accessToken) {

        PowerBIAccess.getPowerBIEmbeddedToken(datasetId, reportId, accessToken)
          .then((response) => response.json())
          .then((result) => {
            const powerBIToken = result.token;
            PowerBIAccess.getReportById(reportId, accessToken, groupId)
              .then(async (res) => {
                const result1 = await res.json();
                let embedUrl = result1.embedUrl;
                
                embedPowerBIReport(powerBIToken, embedUrl, reportId);
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((error) => console.log("error", error));
      }
    });
  }, []);

 function embedPowerBIReport(token, url, embedReportId) {
  const config = {
    type: "report",
    tokenType: models.TokenType.Embed,
    accessToken: token,
    embedUrl: url,
    id: embedReportId,
    permissions: models.Permissions.All,
    filters: [
      {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Reports",
          column: "MeasureID",
        },
        operator: "In",
        values: [Number(measureId)],
      },
      {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: "Clients",
          column: "UserID",
        },
        operator: "In",
        values: [Number(clientId)],
      }
    ],
    settings: {
      panes: {
        filters: { visible: false },
        pageNavigation: { visible: false },
      },
      bars: {
        statusBar: { visible: false },
      },
    },
  };
  setReportConfig(config);
}
  return (
    <div>
      {sampleReportConfig && sampleReportConfig.embedUrl && (
        <PowerBIEmbed
          cssClassName={reportClass}
          embedConfig={sampleReportConfig}
        />
      )}
    </div>
  );
};

export default PowerBiChart;
